import { css } from '@emotion/react';

export const outline = {
  outline_none: css`
    outline: 0;
  `,
};
